import React from "react"
import Typography from "@mui/material/Typography"
import Link from "@mui/material/Link"
const ContactDetails = ({ data }) => {
  return (
    <div style={{ display: "flex", flexDirection: "row", gap: "0.5rem" }}>
      {data?.contactNumber && (
        <Typography
          color="white.main"
          variant="small"
          sx={{
            textDecoration: "underline",
            textUnderlineOffset: "0.2rem",
            textDecorationColor: "rgba(255, 255, 255, 0.4)",
            "&:hover": { textDecorationColor: "rgba(255, 255, 255, 0.6)" },
          }}
        >
          <a
            className="link-animation"
            href={`tel:${data.contactNumber.replace(/\s+/g, "")}`}
          >
            {data.contactNumber}
          </a>
        </Typography>
      )}

      <Typography
        color="white.main"
        variant="small"
        sx={{
          textDecoration: "underline",
          textUnderlineOffset: "0.2rem",
          textDecorationColor: "rgba(255, 255, 255, 0.4)",
          "&:hover": { textDecorationColor: "rgba(255, 255, 255, 0.6)" },
        }}
      >
        <a className="link-animation" href={`mailto:${data?.email}`}>
          {data?.email}
        </a>
      </Typography>
      <Typography color="white.main" variant="small">
        {data?.businessHours}
      </Typography>
    </div>
  )
}

export default ContactDetails
